import React from 'react'
import styled, { css } from 'styled-components'

const StyledButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.2s;
    cursor: pointer;
    border: 1px solid transparent;
    outline: none;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    ${(props) =>
        props.variant === 'primary' &&
        css`
            background-color: #007bff;
            color: white;
            &:hover:not(:disabled) {
                background-color: #0069d9;
            }
        `}

    ${(props) =>
        props.variant === 'secondary' &&
        css`
            background-color: #6c757d;
            color: white;
            &:hover:not(:disabled) {
                background-color: #5a6268;
            }
        `}

  ${(props) =>
        props.variant === 'outline' &&
        css`
            background-color: transparent;
            border-color: #007bff;
            color: #007bff;
            &:hover:not(:disabled) {
                background-color: #007bff;
                color: white;
            }
        `}

  ${(props) =>
        props.size === 'sm' &&
        css`
            padding: 0.25rem 0.5rem;
            font-size: 0.875rem;
        `}

  ${(props) =>
        props.size === 'md' &&
        css`
            padding: 0.5rem 1rem;
            font-size: 1rem;
        `}

  ${(props) =>
        props.size === 'lg' &&
        css`
            padding: 0.75rem 1.5rem;
            font-size: 1.25rem;
        `}
`

const Button = ({ children, variant = 'primary', size = 'md', ...props }) => {
    return (
        <StyledButton variant={variant} size={size} {...props}>
            {children}
        </StyledButton>
    )
}

export default Button
